module.exports = __webpack_public_path__ + "assets/9adc81f9ca823a23d1330ae996d79e74.png";